import { useAuth0 } from "@auth0/auth0-react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { FC } from "react";
import { getFieldCompanyId, listFieldCompanyIds } from "shell/services/fieldCompanyService";
import useStyles from "./styles";
import localisations from "shell/localisation/index";

interface FieldCompanySelectorProps {}

const FieldCompanySelector: FC<FieldCompanySelectorProps> = (props: FieldCompanySelectorProps) => {
    const classes = useStyles();

    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    const fieldCompanyIds = listFieldCompanyIds(user);

    const componentText = localisations.components.fieldCompany;

    return (
        <>
            <FormControl className={classes.formControl}>
                <InputLabel id="field-company-input-label">{componentText.fieldCompanyIdLabel}</InputLabel>
                <Select
                    labelId="field-company-input-label"
                    id="field-company-select"
                    value={fieldCompanyId}
                    onChange={() => {}}
                >
                    {fieldCompanyIds.map((fieldCompanyId, index) => {
                        return (
                            <MenuItem disabled={true} key={index} value={fieldCompanyId}>
                                {fieldCompanyId}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </>
    );
};

export default FieldCompanySelector;
